module.exports = __webpack_public_path__ + "static/img/10.c53f417.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/10.png
// module id = tRge
// module chunks = 0